import styled from 'styled-components';
import TreeSelectorItem from './TreeSelectorItem';
import { grey50 } from 'styles/colors';

export const Wrapper = styled.div`
	display: flex;
`;

export const LevelTitle = styled.div`
	text-transform: uppercase;
	height: 13px;
	font-size: 11px;
	letter-spacing: 0.8px;
	line-height: 13px;
	margin-bottom: 11px;
	user-select: none;
`;

export const Level = styled.div`
	display: inline-block;
	min-width: 272px;
	margin-right: 15px;
	border-right: 1px solid ${grey50};
	padding-left: 3px;
`;

export const TreeSelectorList = styled.ul`
	position: relative;
	height: 260px;
	overflow: auto;
`;

export const AllCheckbox = styled(TreeSelectorItem)`
	margin-bottom: 10px;
`;
